import {inject, Injectable} from '@angular/core';
import { Router } from '@angular/router';
import {AuthService} from "@usheru-hff/authentication/domain";

@Injectable({
  providedIn: 'root'
})
export class LoggedinUserGuard {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate() {
    const isUserLoggedIn = this.authService?.isLoggedIn();
    if (isUserLoggedIn) {
      return true;
    } else {
      this.router.navigate(['/']);
      return false;
    }
  }
}
